/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Finn nye venner med Bumble For Friends-appen | Bumble",
      "Last ned i App Store",
      "Få den i Google Play",
      "En dedikert plattform for nye vennskap",
      "Oppdag folk i nærheten som ser etter genuine og ekte forbindelser.",
      "Finn vennskap for alle deler av livet",
      "Ny i byen? Lyst å finne på nye ting? Nye vennskap venter!",
      "Et trygt sted for alle",
      "Velkommen til en vennlig del av nettet, hvor du kan være deg selv.",
      "Last ned appen",
      "Treff folk i virkeligheten som deler interessene dine!",
      "Bli kjent med nye mennesker med Plans på Bumble For Friends",
      "Du er invitert til å bli med på Plans",
      "Plans er en ny funksjon på Bumble For Friends hvor du kan lage og bli med på grupper, og lage planer med nye venner",
      "Administrer cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dager"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "timer"
            ],
            "singular": [
                  "time"
            ]
      },
      "minute": {
            "plural": [
                  "minutter"
            ],
            "singular": [
                  "minutt"
            ]
      },
      "month": {
            "plural": [
                  "måneder"
            ],
            "singular": [
                  "måned"
            ]
      },
      "second": {
            "plural": [
                  "sekunder"
            ],
            "singular": [
                  "sekund"
            ]
      },
      "year": {
            "plural": [
                  "år"
            ],
            "singular": [
                  "år"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
